export default "__VITE_ASSET__BZ8p6RQO__"